import React from 'react';
import PropTypes from 'prop-types';
import Button from '@ingka/button';

const Url = ({ cms, storeOpened, activateAnalytics, colorButton, buttonStyles, ariaLabel }) => {
    const { contactLabel, buttonLink } = cms;

    const activateContactAndAnalystics = () => {
        activateAnalytics('Button');
        window.location.assign(buttonLink);
    };

    return (
        <Button
            data-cy="contactcard-button"
            type={colorButton}
            aria-label={ariaLabel}
            className={buttonStyles}
            onClick={() => activateContactAndAnalystics()}
            disabled={!storeOpened}
        >
            {contactLabel}
        </Button>
    );
};

Url.propTypes = {
    cms: PropTypes.object,
    activateAnalytics: PropTypes.func,
    ariaLabel: PropTypes.string,
    index: PropTypes.number,
    contactType: PropTypes.string,
    contactLabel: PropTypes.string,
    colorButton: PropTypes.string,
    buttonStyles: PropTypes.string,
    buttonLink: PropTypes.string,
    storeOpened: PropTypes.bool,
};
export default Url;
